module.exports = __webpack_public_path__ + "img/btn_google_signin.4ef45090.png";